import { Form } from "@quillforms/renderer-core";
import "@quillforms/renderer-core/build-style/style.css";
import { registerCoreBlocks } from "@quillforms/react-renderer-utils";
import "./index.css";
registerCoreBlocks();

const App = () => {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <Form
        formId="1"
        formObj={{
          blocks: [
            // {
            //   name: "welcome-screen",
            //   id: "jg1401r",
            //   attributes: {
            //     label: "<b>Jetzt Erstgespräch anfragen</b>",
            //     // description: "This is just a description",
            //     // attachment: {
            //     //   type: "image",
            //     //   url: "https://uploads-ssl.webflow.com/650f5810788d34c5900f9403/65129bb2b8cbcd755866ead0_image%2041-1.webp",
            //     // },
            //     buttonText: "Los gehts!",
            //   },
            // },
            {
              name: "short-text",
              id: "name-text-field",
              attributes: {
                required: true,
                label: "Wie lautet Ihr Name?",
              },
            },
            {
              name: "short-text",
              id: "company-name-text-field",
              attributes: {
                // attachment: {
                //   type: "image",
                //   url: "https://uploads-ssl.webflow.com/650f5810788d34c5900f9403/65129bb2b8cbcd755866ead0_image%2041-1.webp",
                // },
                // layout: "float-right",
                required: true,
                label: "Wie lautet der Name Ihres Unternehmens?",
              },
            },
            {
              name: "multiple-choice",
              id: "industries-text-field",
              attributes: {
                required: true,
                multiple: true,
                verticalAlign: false,
                label: "In welcher Branche sind Sie tätig?",
                choices: [
                  {
                    label: "Zerspanung",
                    value: "Zerspanung",
                  },
                  {
                    label: "Metall- und Stahlbau",
                    value: "Metall- und Stahlbau",
                  },
                  {
                    label: "Auto­mati­sierungs­technik",
                    value: "Automatisierungstechnik",
                  },
                  {
                    label: "Maschinenbau",
                    value: "Maschinenbau",
                  },
                  {
                    label: "Bauwesen",
                    value: "Bauwesen",
                  },
                  {
                    label: "Kunststoff",
                    value: "Kunststoff",
                  },
                  {
                    label: "Sonstiges",
                    value: "Sonstiges",
                  },
                ],
              },
            },
            {
              name: "multiple-choice",
              id: "employees-count-text-field",
              attributes: {
                required: true,
                multiple: false,
                verticalAlign: false,
                label: "Wie viele Mitarbeiter beschäftigen Sie aktuell?",
                choices: [
                  {
                    label: "0 bis 25",
                    value: "0 bis 25",
                  },
                  {
                    label: "25 bis 50",
                    value: "25 bis 50",
                  },
                  {
                    label: "50 bis 100",
                    value: "50 bis 100",
                  },
                  {
                    label: "100 bis 300",
                    value: "100 bis 300",
                  },
                  {
                    label: "300 bis 1000",
                    value: "300 bis 1000",
                  },
                  {
                    label: "Über 1000",
                    value: "Über 1000",
                  },
                ],
              },
            },
            {
              name: "email",
              id: "email-address-text-field",
              attributes: {
                required: true,
                label: "Wie lautet Ihre E-Mail-Adresse?",
              },
            },

            {
              name: "short-text",
              id: "phone-number-text-field",
              attributes: {
                required: true,
                label: "Wie lautet Ihre Telefonnummer?",
              },
            },
            // {
            //   name: "long-text",
            //   id: "employee-kind-text-field",
            //   attributes: {
            //     required: true,
            //     label:
            //       "In welchen Bereichen benötigen Sie neue Mitarbeiter oder Azubis?",
            //   },
            // },
            // {
            //   name: "statement",
            //   id: "ks126dg",
            //   attributes: {
            //     attachment: {
            //       type: "image",
            //       url: "https://uploads-ssl.webflow.com/650f5810788d34c5900f9403/65154045f8d574135f449000_DSC01573.webp",
            //     },
            //     layout: "float-right",
            //     label: "Sehr gut, jetzt nur noch Ihre Kontaktdaten!",
            //     buttonText: "Weiter",
            //     quotationMarks: true,
            //   },
            // },
            // {
            //   name: "date",
            //   id: "a213rsew",
            //   attributes: {
            //     required: true,
            //     label: "Please type your birth of date!",
            //   },
            // },
            // {
            //   name: "website",
            //   id: "bv91em9123",
            //   attributes: {
            //     required: true,
            //     multiple: true,
            //     label: "Please insert your website url!",
            //   },
            // },
            // {
            //   name: "number",
            //   id: "wer3qdkdb",
            //   attributes: {
            //     required: true,
            //     label: "Great {{field:kdsfkdg}}, can you type your age?",
            //   },
            // },
            // {
            //   name: "long-text",
            //   id: "m35612edg",
            //   attributes: {
            //     required: true,
            //     label: "Type a brief about yourself!",
            //   },
            // },
            // {
            //   name: "dropdown",
            //   id: "3nsdf934",
            //   attributes: {
            //     choices: [
            //       {
            //         label: "Automobilindustrie",
            //         value: "automobilindustrie",
            //       },
            //       {
            //         label: "Maschinenbau",
            //         value: "maschinenbau",
            //       },
            //       {
            //         label: "Metallverarbeitung",
            //         value: "metallverarbeitung",
            //       },
            //       {
            //         label: "Elektrotechnik",
            //         value: "elektrotechnik",
            //       },
            //       {
            //         label: "Bauwesen",
            //         value: "bauwesen",
            //       },
            //       {
            //         label: "Schweißtechnik",
            //         value: "schweisstechnik",
            //       },
            //       {
            //         label: "Sanitär-, Heizungs- und Klimatechnik",
            //         value: "sanitaer_heizung_klimatechnik",
            //       },
            //       {
            //         label: "Schlosserei und Schmiedekunst",
            //         value: "schlosserei_schmiedekunst",
            //       },
            //       {
            //         label: "Zerspanungs- und Blechbearbeitung",
            //         value: "zerspanung_blechbearbeitung",
            //       },
            //       {
            //         label: "Stahl- und Anlagenbau",
            //         value: "stahl_anlagenbau",
            //       },
            //       {
            //         label:
            //           "Fahrzeugbau (inkl. Schiff-, Flugzeug- und Eisenbahnfahrzeugbau)",
            //         value: "fahrzeugbau",
            //       },
            //       {
            //         label: "Sonstiges",
            //         value: "sonstiges",
            //       },
            //     ],
            //     label: "In welcher Branche sind Sie tätig?",
            //   },
            // },
          ],
          settings: {
            animationDirection: "vertical",
            disableWheelSwiping: true,
            disableNavigationArrows: false,
            disableProgressBar: true,
          },
          theme: {
            font: "Arial",
            buttonsBgColor: "#007aff",
            // logo: {
            //   src: "https://uploads-ssl.webflow.com/650f5810788d34c5900f9403/65109153ed1e0a83e7c00fb3_logo.svg",
            // },
            questionsColor: "#000000",
            answersColor: "#4d4d4d",
            buttonsFontColor: "#ffffff",
            buttonsBorderRadius: 5,
            errorsFontColor: "#ff3b30",
            errorsBgColor: "#fee2e2",
            progressBarFillColor: "#22c55e",
            progressBarBgColor: "#dcfce7",
          },
          messages: {
            "label.button.ok": "Ok",
            "label.hintText.enter": "Drücken Sie <strong>Enter ↵</strong>",
            "label.hintText.multipleSelection":
              "Wählen Sie so viele wie Sie möchten",
            "block.dropdown.placeholder": "Tippen oder wählen Sie eine Option",
            "block.dropdown.noSuggestions": "Keine Vorschläge!",
            "block.shortText.placeholder": "Geben Sie hier Ihre Antwort ein",
            "block.longText.placeholder": "Geben Sie hier Ihre Antwort ein",
            "block.longText.hint":
              "<strong>Shift ⇧ + Enter ↵</strong> um einen Zeilenumbruch zu machen",
            "block.number.placeholder": "Geben Sie hier Ihre Antwort ein",
            "block.email.placeholder": "Geben Sie hier Ihre E-Mail ein",
            "block.defaultThankYouScreen.label":
              "Vielen Dank für Ihre Anfrage!",
            "label.hintText.key": "Shortcut",
            "label.progress.percent": "{{progress:percent}}% abgeschlossen",
            "label.errorAlert.required": "Dieses Feld ist erforderlich!",
            "label.errorAlert.date": "Ungültiges Datum!",
            "label.errorAlert.number": "Nur Zahlen erlaubt!",
            "label.errorAlert.selectionRequired":
              "Bitte treffen Sie mindestens eine Auswahl!",
            "label.errorAlert.email": "Ungültige E-Mailadresse!",
            "label.errorAlert.url": "Ungültige URL!",
            "label.errorAlert.range":
              "Bitte geben Sie eine Zahl zwischen {{attribute:min}} und {{attribute:max}} ein",
            "label.errorAlert.minNum":
              "Bitte geben Sie eine Zahl größer als {{attribute:min}} ein",
            "label.errorAlert.maxNum":
              "Bitte geben Sie eine Zahl kleiner als {{attribute:max}} ein",
            "label.errorAlert.maxCharacters":
              "Maximale Zeichenanzahl erreicht!",
            "label.submitBtn": "Jetzt Erstgespräch vereinbaren",
          },
        }}
        onSubmit={(
          data,
          { completeForm, setIsSubmitting, goToBlock, setSubmissionErr }
        ) => {
          let message = {
            type: "formSubmission",
            data: {
              name: data.answers["name-text-field"].value,
              companyName: data.answers["company-name-text-field"].value,
              industries:
                data.answers["industries-text-field"].value.join(", "),
              employeesCount: data.answers["employees-count-text-field"].value,
              // employeeKind: data.answers["employee-kind-text-field"].value,
              emailAddress: data.answers["email-address-text-field"].value,
              phoneNumber: data.answers["phone-number-text-field"].value,
            },
          };
          window.parent.postMessage(message, "*");
          completeForm();
        }}
      />
    </div>
  );
};

export default App;
